import React from 'react';

interface ErrorMessageProps {
  className?: string;
  message?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ className, message }) => {
  if (!message) {
    return null;
  }

  return (
    <div className={`text-start text-red-500 ${className}`}>
      <p>{message}</p>
    </div>
  );
};
export default ErrorMessage;
